import { useContext } from "react";
import { I18NContext } from "./i18n-provider";
const useI18N = () => useContext(I18NContext)!;
export { useI18N };
